(function() {
	/**
	 * Renders webcams list page: [Webcam Item]
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object} 	Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderWebcamsPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/webcams.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				navRaw: null,
				webcamsRaw: null,
				categories: null,
				webcams: null,
				nav: null,
				pageContent: null
			}
		};
		var queryString = WebBaseAprovLV.Utils.parseQuerystring(props.context.querystring);
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=2'),
			(function() {
				var cache = WebBaseAprovLV.Cache.get('taxonomies.webcam_locations').value;
				if (cache) {
					return $.Deferred().resolve(cache).promise();
				}
				return WebBaseAprovLV.Utils.getTaxonomies({groupname: 'webcam_locations'});
			})()
		)
		.then(function(pageXhr, taxonomiesXhr) {
			var pageRaw = Array.isArray(pageXhr) && pageXhr.length ? pageXhr[0] : (pageXhr || {});
			var taxonomies = Array.isArray(taxonomiesXhr) ? taxonomiesXhr[0] : taxonomiesXhr;
			var limit = 200;
			var filters = {
				categories: (queryString.categories || '').toLowerCase()
			};
			var categoryQueries = [];
			var categoryQueryString = '';
			var categories = model.data.categories = taxonomies.terms || [
				{
					codename: 'news_news',
					name: 'News|News'
				}
			];
			var orderParams = [{
				field: (queryString.order || '').toLowerCase(),
				dir: (queryString.dir || '').toLowerCase(),
				value: ''
			}];
			var orderQueries = [];
			var orderQueryString = '';
			WebBaseAprovLV.Cache.set('taxonomies.webcam_locations', taxonomies);
			if (pageRaw.items && Array.isArray(pageRaw.items) && pageRaw.items.length) {
				model.data.pageRaw = pageRaw;
				if (filters.categories.length) {
					categoryQueries = categories.filter(function(item) {
						return (new RegExp('(^|,)' + item.codename + '(,|$)', 'i')).test(filters.categories);
					}).map(function(item) {
						return item.codename;
					});
					if (categoryQueries.length) {
						categoryQueryString = '&elements.webcam_locations';
						if (categoryQueries.length === 1) {
							categoryQueryString += '[contains]=' + encodeURIComponent(categoryQueries[0]);
						} else if (categoryQueries.length > 1) {
							categoryQueryString += '[any]=' + encodeURIComponent(categoryQueries.join(','));
						}
					}
				}
				orderQueries = orderParams.map(function(item) {
					item.dir = /^(asc|desc)?$/i.test(item.dir) ? item.dir : '';
					switch (item.field) {
						case 'last_modified':
							item.dir = item.dir.length ? item.dir : 'desc';
							item.value = ['system.last_modified[', item.dir, ']'].join('');
							break;
						case 'title':
							item.dir = item.dir.length ? item.dir : 'asc';
							item.value = ['elements.title[', item.dir, ']'].join('');
							break;
						default:
							item.dir = item.dir.length ? item.dir : 'desc';
							item.value = ['elements.date_from[', item.dir, ']'].join('');
					}
					return item;
				}).filter(function(item) {
					return item.value.length > 0;
				}).map(function(item) {
					return item.value;
				});
				orderQueryString = orderQueries.length ? '&order=' + orderQueries.join(',') : '';
				return WebBaseAprovLV.Utils.getKKData('?system.type=webcam_item&includeTotalCount=true' + categoryQueryString + orderQueryString + (queryString.skip ? '&skip=' + queryString.skip : '') + '&limit=' + limit);
			}
			return $.Deferred().reject(model);
		}).then(function(webcamsRaw) {
			var key;
			var params = [];
			var paramsDict = {};
			webcamsRaw = webcamsRaw || {};
			model.data.webcamsRaw = webcamsRaw;
			model.data.navRaw = {};
			if (model.data.pageRaw && model.data.webcamsRaw) {
				for (key in queryString) {
					switch (true) {
						case /^(skip|limit)/i.test(key):
							break;
						default:
							params.push([key.toLowerCase(), queryString[key]].join('='));
							paramsDict[key.toLowerCase()] = queryString[key];
							break;
					}
				}
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
					nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
					webcams: (model.data.webcamsRaw.items || []).length ? WebBaseAprovLV.Utils.getKKViewModel(model.data.webcamsRaw) || [] : [],
					queryStringCollection: paramsDict,
					queryString: params.join('&')
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			}
			return $.Deferred().reject(model);
		}).promise();
	};
})();
